export enum ContentType {
  AccessGroup = 'application/vnd.io.idaas.admin.api.access.group.v1+json',
  AccessGroupUsers = 'application/vnd.io.idaas.admin.api.access.group.users.v1+json',
  AccessGroupRule = 'application/vnd.io.idaas.admin.api.user.rule.v1+json',
  AccessPolicy = 'application/vnd.io.idaas.admin.api.application.access.v1+json',
  Application = 'application/vnd.io.idaas.admin.api.application.v1+json',
  ApplicationAccess = 'application/vnd.io.idaas.admin.api.application.access.v1+json',
  ApplicationUsers = 'application/vnd.io.idaas.admin.api.application.users.v1+json',
  Certificate = 'application/vnd.io.idaas.admin.api.certificate.v1+json',
  Client = 'application/vnd.io.idaas.admin.api.client.v1+json',
  Credentials = 'application/vnd.io.idaas.admin.api.credentials.v1+json',
  Enterprise = 'application/vnd.io.idaas.admin.api.enterprise.v2+json',
  PasswordValidation = 'application/vnd.io.idaas.admin.api.password.validation.v1+json',
  Registration = 'application/vnd.io.idaas.admin.api.registration.v1+json',
  RegistrationInvite = 'application/vnd.io.idaas.admin.api.registration.invite.v1+json',
  Resend = 'application/vnd.io.idaas.admin.api.resend.v1+json',
  Reset = 'application/vnd.io.idaas.admin.api.reset.v1+json',
  SecretRefresh = 'application/vnd.io.idaas.admin.api.secret.refresh.v1+json',
  EmailVerification = 'application/vnd.io.idaas.admin.api.email.verification.v1+json',
  DnsVerification = 'application/vnd.io.idaas.admin.api.dns.verification.v1+json',
  VerificationToken = 'application/vnd.io.idaas.admin.api.verification.token.v1+json',
  Csv = 'text/csv',
  Txt = 'text/plain',
}
